import { Helpers } from '../../helpers';
import { ICashCurveType } from '../../interfaces/icash-curve-type';
import { ProjectCashCurve } from '../project-cash-curve';

export class CashCurveTypeBase {
  CashCurveTypeId: number;
  Description: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectCashCurves_CashCurveType?: Array<ProjectCashCurve> | null;

  constructor(item?: ICashCurveType) {
    if (item) {

      this.CashCurveTypeId = item.CashCurveTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectCashCurves_CashCurveType = Helpers.createClassArray(ProjectCashCurve, item.ProjectCashCurves_CashCurveType);
    }
  }
}